export default __webpack_public_path__ + "static/media/earth2-9.2089bed6.jpg";